import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import avoirReducer from './avoirSlice';
import siteReducer from './siteSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    avoir: avoirReducer,
    site: siteReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
